import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { SikkerInnsendingService } from "../../../../../projects/api/services/sikker-innsending.service";
import { UserService } from "../../../shared/services/user.service";
import { ButtonComponent } from "@husbanken/designsystem-angular-core";


@Component({
  selector: 'app-bekreftelse',
  templateUrl: './bekreftelse.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    NgClass,
    ButtonComponent,
  ],
  standalone: true
})

export class BekreftelseComponent {
  erSkjermSmal: boolean = false
  readonly MAKS_ANTALL_PIKSLER: number = 768;


  constructor(private userService: UserService, private sikkerInnsendingService: SikkerInnsendingService) {
    this.erSkjermSmal = this.sjekkSkjerm(window.innerWidth)
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.erSkjermSmal = this.sjekkSkjerm(window.innerWidth);
  }

  loggUt() {
    console.log('Logger ut');
    this.userService.logout();
  }

  sjekkSkjerm(bredde: number) {
    return bredde < this.MAKS_ANTALL_PIKSLER;
  }
}
